import React, { useContext } from 'react'
import { Navigate } from 'react-router-dom'

import { AdminContext } from 'contexts'

const ProtectedRoutes: React.FC = ({ children }) => {
  const { admin } = useContext(AdminContext)

  if (!admin) return <Navigate to="/login" replace />

  return <>{children}</>
}

export { ProtectedRoutes }
